import { MatchDetailsStylesSchema } from './NewMatchDetailsPage.styles';

export const matchDetailsStyles: MatchDetailsStylesSchema = {
  headerFlex: {
    justify: 'space-between',
  },
  headerHeading: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 'md',
    color: 'white',
    fontWeight: 'medium',
  },
  headerIconButton: {
    color: 'white',
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: {
      opacity: '.8',
    },
  },
  headerVsBox: {
    color: 'white',
  },
  bodyStack: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    p: ['2', null, null, '4'],
    minH: '90vh',
  },
  bodyInnerWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sgmLogo: {
    color: 'beta.500',
    h: '1.25em',
    ml: '1',
    w: 'auto',
    _before: {
      bg: 'blue',
      color: 'blue',
    },
  },
  scrollButtonGroup: {
    variant: 'filter',
    boxShadow: 'none',
    bg: 'none',
    maxH: '9',
    pos: 'relative',
  },
  toMarketButton: {
    borderColor: 'beta.500',
    color: 'white',
    _hover: {
      color: 'beta.500',
    },
    _last: { mr: 2 },
  },
  loadingSkeletonText: {
    my: '4',
    spacing: '4',
    skeletonHeight: '2',
  },
  accordion: {
    display: 'flex',
    flexDir: ['column', null, null, 'row'],
    mx: '-1',
  },
  accordionStack: {
    px: '1',
    w: { lg: '50%' },
    _notFirst: {
      mt: ['2', null, null, '0'],
    },
  },
  accordionItem: {
    bgGradient: 'linear(180deg, delta.100 0%, delta.200 100%)',
    border: '0',
    borderRadius: 'base',
    boxShadow: '0px -2px 0px 0px rgba(0, 0, 0, 0.15) inset',
    overflow: 'hidden',
  },
  accordionButton: {
    fontSize: 'xs',
    fontWeight: 'bold',
    p: '2',
    pos: 'relative',
    textAlign: 'left',
    _after: {
      borderBottomWidth: '1px',
      borderColor: 'blackAlpha.400',
      bottom: '0',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      left: '0',
      opacity: '0',
      pos: 'absolute',
      right: '0',
      transition: 'inherit',
      zIndex: '1',
    },
    _expanded: {
      _after: { opacity: '1' },
    },
  },

  marketLayoutIconFlex: {
    align: 'center',
    flex: '1',
    gap: '1',
    color: 'delta.700',
    fontSize: 'sm',
    fontWeight: 'bold',
  },
  marketLayoutTooltip: {
    fontSize: 'xs',
  },
  marketLayoutIcon: {
    color: 'delta.700',
    fontSize: 'lg',
  },
  marketLoadingCenter: {
    boxSize: '6',
  },
  centerLoadingSpinner: {
    color: 'white',
    size: 2,
  },
  marketLayoutLoadedIcon: {
    color: 'delta.700',
    fontSize: '2xl',
  },
  marketLayoutAccordionPanel: {
    bg: 'white',
    p: '0',
  },
  cancelButton: {
    variant: 'solid',
    px: '3',
  },
  clearButton: {
    variant: 'solid',
    ml: '3',
    px: '3',
  },
  countdown: {
    sx: {
      textTransform: 'uppercase',
      '&&&.state-prior': {
        p: 0,
        lineHeight: 'initial',
      },
    },
  },
  sgmLogoV2: {
    color: 'white',
    w: '8',
    h: 'auto',
  },
  wrapperScrollSgm: { w: '100%', maxW: '100%', gap: '2', mt: '2' },
  scrollButtonGroupV2: {
    variant: 'unstyled',
    flex: 1,
    position: 'relative',
    minH: '34px',
    bg: 'none',
    boxShadow: 'none',
  },
  accordionItemActive: {
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
  },
  toMarketButtonV2: {
    color: 'white',
    fontSize: 'xs',
    textTransform: 'uppercase',
    minW: 'fit-content',
    fontWeight: 'bold',
    cursor: 'pointer',

    sx: {
      '&&': {
        px: 2,
        ml: 0,
      },

      '&[data-active]': {
        color: 'beta.500',
      },

      '.chakra-button__icon': {
        margin: 0,
      },
    },

    _last: { mr: 2 },
  },
  sgmBtn: {
    bgGradient: 'linear(to-b, alpha.400, alpha.500)',
    borderColor: 'white',
    borderStyle: 'solid',
    borderWidth: '2px',
    boxShadow:
      '0px 2px 6px 0px rgba(0, 0, 0, 0.35), 0px 0px 0px 4px rgba(0, 0, 0, 0.20) inset',
    sx: {
      svg: {
        color: 'white',
        fill: 'white',
      },
    },
  },
  sgmBtnActive: {
    sx: {
      svg: {
        color: 'beta.400',
        fill: 'beta.400',
      },

      '&&': {
        bg: 'alpha.900',
        boxShadow:
          '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 2px 3px 0px rgba(0, 0, 0, 0.50) inset',
        borderColor: 'transparent',
      },
    },

    _after: { display: 'none' },
  },
};
